import { render, staticRenderFns } from "./UsageDonutChart.vue?vue&type=template&id=7658f845"
import script from "./UsageDonutChart.vue?vue&type=script&lang=js"
export * from "./UsageDonutChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports